import { useIntl } from 'react-intl';
import { DatePicker, Input, Switch } from '../../../../ui';
import { StyledBusinessTab } from '../style';

export const Contracts = () => {
  const intl = useIntl();

  return (
    <StyledBusinessTab>
      <div className={'input-filelist column'}>
        <div className={'double-input-date'}>
          <Input
            label={intl.formatMessage({ id: 'contracts.contract_number' })}
            name={'emarket_contract_nr'}
            validations={'required'}
          />
          <DatePicker
            label={intl.formatMessage({
              id: 'contracts.date_conclusion_contract',
            })}
            name={'emarket_contract_date'}
            validations={'required'}
            format="YYYY-MM-DD"
          />
        </div>

        <Switch
          label={intl.formatMessage({ id: 'contracts.paid' })}
          name={'emarket_pay'}
        />

        <Switch
          label={intl.formatMessage({ id: 'general.e_market' })}
          name={'emarket'}
        />
        <Input
          label={intl.formatMessage({
            id: 'contracts.bank_account_number_full',
          })}
          name={'emarket_bank_account'}
          validations={'farmBankAccount'}
        />
      </div>
    </StyledBusinessTab>
  );
};
